// Navbar.js
import React, { useState } from 'react';
import Menu from "./images/menu1.png"
import Close from "./images/close1.png"
import Logo from "./images/Logo.jpg"
import X from "./images/x1.png"
import IG from "./images/ig1.png"
import fb from "./images/fb1.png"
import tg from "./images/tg.png"
const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="navbar">
      <div className="logo"><img src={Logo} alt="logo" />
      {/* <h1>The Crickter Bro</h1> */}
      </div>
      <div className="menu-button" onClick={toggleMenu}>
        <img src={Menu} alt="menu" />
      </div>

      {isMenuOpen && (
        <div className="menu">
          <div className="cancel-button" onClick={closeMenu}>
          <img src={Close} alt="menu" />
          </div>
          <div className="menu-body">
          <div className="social-media-links">
        <h2>Follow us here:-
        </h2>
        {/* Add links to your social media handles */}
        <a href="https://x.com/TheCricketerBro" target="_blank" rel="noopener noreferrer">
          <img src={X} alt="x" />
        </a>
        <a href="https://instagram.com/the_cricketers_bro?igshid=OGQ5ZDc2ODk2ZA/" target="_blank" rel="noopener noreferrer">
        <img src={IG} alt="x" />
        </a>
        <a href="https://www.facebook.com/TheCricketerBro/" target="_blank" rel="noopener noreferrer">
        <img src={fb} alt="x" />
        </a>
        <a href="https://t.me/The_Cricketer_Bro" target="_blank" rel="noopener noreferrer">
        <img src={tg} alt="x" />
        </a>
        <div>Devloped by:-
        <a href="https://t.me/webdevloper_7" target="_blank" rel="noopener noreferrer" ><h2>Webdevloper</h2> </a>
      </div>
        </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
